import React, { useState } from 'react';
import { Select, TabsProps } from 'antd';

import EventFilterContainer from '@totem/components/services/threats/eventFilters/EventFilterContainer';
import EventFilters from '@totem/components/services/threats/eventFilters/EventFilters';
import EventContainerTable from '@totem/components/services/threats/eventsContainer_legacy/EventContainerTable';
import EventEmbeddedContainer from '@totem/components/services/threats/eventsContainer_legacy/EventEmbeddedContainer';
import EventExportButton from '@totem/components/services/threats/eventsContainer_legacy/EventExportButton';
import EventGraphsContainer from '@totem/components/services/threats/graphs/EventGraphsContainer';
import EventGraphsLayout from '@totem/components/services/threats/graphs/EventGraphsLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';
import { EVENTS_ENDPOINT } from '@totem/utilities/endpoints';

const styles = {
  totals: {
    fontSize: '16px',
  },
  tabContainer: {
    paddingRight: '2rem',
    paddingLeft: '2rem',
  },
};

const EventsPage = () => {
  const [section, setSection] = React.useState<string>('Active');
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [totalRecordsCleared, setTotalRecordsCleared] = useState<number>(0);

  const tabItems: TabsProps['items'] = [
    {
      key: 'summary',
      label: 'Summary',
      children: (
        <EventGraphsContainer>
          <EventGraphsLayout />
        </EventGraphsContainer>
      ),
    },
    {
      key: 'details',
      label: 'Details',
      children: <EventContainerTable />,
    },
  ];

  const tabItemsHistory: TabsProps['items'] = [
    {
      key: 'summary',
      label: 'Summary',
      children: (
        <EventGraphsContainer
          eventEndPoint={`${EVENTS_ENDPOINT}/cleared/graphData`}
        >
          <EventGraphsLayout />
        </EventGraphsContainer>
      ),
    },
    {
      key: 'details',
      label: 'Details',
      children: <EventContainerTable />,
    },
  ];

  return (
    <ContentLayout>
      <IBCard
        isCovered
        title={`Event Management - ${section}`}
        extra={
          <Select
            value={section}
            options={[
              { value: 'Active', label: 'Active' },
              { value: 'History', label: 'History' },
            ]}
            onChange={(newValue) => setSection(newValue)}
          />
        }
      >
        {section === 'Active' && (
          <EventFilterContainer>
            <EventEmbeddedContainer onRecordTotalChanged={setTotalRecords}>
              <EventFilters />
              <IBTabs
                defaultActiveKey="summary"
                tabBarExtraContent={
                  <>
                    <EventExportButton />
                    {'  '}
                    <RecordCountBadge count={totalRecords} />
                  </>
                }
                style={styles.tabContainer}
                items={tabItems}
              />
            </EventEmbeddedContainer>
          </EventFilterContainer>
        )}
        {section === 'History' && (
          <EventFilterContainer
            staticFilters={{ status: ['CLEARED'] }}
            historyOnly
          >
            <EventEmbeddedContainer
              eventEndPoint={`${EVENTS_ENDPOINT}/cleared`}
              onRecordTotalChanged={setTotalRecordsCleared}
            >
              <EventFilters />
              <IBTabs
                defaultActiveKey="summary"
                tabBarExtraContent={
                  <>
                    <EventExportButton
                      eventEndPoint={`${EVENTS_ENDPOINT}/cleared`}
                    />
                    {'  '}
                    <RecordCountBadge count={totalRecordsCleared} />
                  </>
                }
                style={styles.tabContainer}
                items={tabItemsHistory}
              />
            </EventEmbeddedContainer>
          </EventFilterContainer>
        )}
      </IBCard>
    </ContentLayout>
  );
};

export default EventsPage;
